var _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLightLogoLightGreen(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 2560,
    zoomAndPan: "magnify",
    viewBox: "0 0 1920 1279.499967",
    height: 1706,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a747ed4f4f"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0.375 0 L 1919.625 0 L 1919.625 1279 L 0.375 1279 Z M 0.375 0 "
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "395916aadf"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 561.023438 0 L 1919.625 0 L 1919.625 1279 L 561.023438 1279 Z M 561.023438 0 "
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: 422923670
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 1206 933 L 1532 933 L 1532 1279 L 1206 1279 Z M 1206 933 "
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "141ad62184"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 1694 546 L 1919.625 546 L 1919.625 819 L 1694 819 Z M 1694 546 "
  })))), /*#__PURE__*/React.createElement("g", {
    id: "b089c3d65a"
  }, /*#__PURE__*/React.createElement("g", {
    clipRule: "nonzero",
    clipPath: "url(#a747ed4f4f)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#ffffff",
      fillOpacity: 1
    },
    d: "M 0.375 0 L 1919.625 0 L 1919.625 1279 L 0.375 1279 Z M 0.375 0 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#739272",
      fillOpacity: 1
    },
    d: "M 0.375 0 L 1919.625 0 L 1919.625 1279 L 0.375 1279 Z M 0.375 0 "
  })), /*#__PURE__*/React.createElement("g", {
    clipRule: "nonzero",
    clipPath: "url(#395916aadf)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#739272",
      fillOpacity: 1
    },
    d: "M 1405.855469 -42.742188 L 561.003906 802.332031 L 1405.855469 1647.402344 L 2250.707031 802.332031 Z M 1405.855469 -42.742188 "
  })), /*#__PURE__*/React.createElement("g", {
    clipRule: "nonzero",
    clipPath: "url(#42292367e1)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#ffffff",
      fillOpacity: 1
    },
    d: "M 1519.253906 1041.960938 C 1473.253906 1023.675781 1438.460938 1043.730469 1407.199219 1061.433594 C 1372.40625 1081.484375 1342.328125 1098.589844 1301.636719 1066.148438 C 1296.921875 1062.613281 1295.152344 1056.707031 1295.742188 1051.402344 C 1303.40625 1000.078125 1313.433594 970.585938 1417.230469 951.121094 L 1421.945312 950.53125 L 1421.945312 938.144531 L 1417.230469 937.554688 C 1356.484375 928.113281 1309.304688 936.964844 1276.871094 964.691406 C 1239.125 996.542969 1220.253906 1053.761719 1219.664062 1138.117188 L 1219.664062 1149.324219 C 1219.664062 1149.324219 1243.84375 1108.621094 1245.023438 1105.675781 C 1242.664062 1128.675781 1234.410156 1147.558594 1226.742188 1165.839844 C 1219.074219 1184.125 1210.820312 1203.007812 1208.460938 1224.828125 L 1206.691406 1240.164062 L 1217.894531 1229.554688 C 1232.640625 1215.984375 1241.484375 1203.007812 1250.332031 1190.027344 C 1257.40625 1180 1263.894531 1170.558594 1272.742188 1161.125 C 1313.433594 1153.453125 1342.921875 1162.304688 1347.636719 1175.871094 C 1351.765625 1187.082031 1338.203125 1203.007812 1311.664062 1217.753906 L 1293.972656 1227.1875 L 1314.023438 1228.367188 C 1322.871094 1228.964844 1332.304688 1226.597656 1342.328125 1224.828125 C 1351.765625 1222.472656 1361.792969 1220.703125 1369.457031 1221.292969 C 1347.636719 1237.21875 1295.152344 1272.027344 1285.125 1277.332031 L 1275.691406 1275.5625 L 1280.996094 1286.183594 C 1282.765625 1289.71875 1283.945312 1293.257812 1285.714844 1296.796875 C 1288.664062 1303.289062 1291.613281 1310.363281 1295.152344 1316.855469 L 1293.972656 1316.855469 L 1305.175781 1417.136719 L 1314.023438 1401.800781 C 1351.175781 1336.910156 1386.5625 1291.488281 1428.429688 1254.914062 L 1429.609375 1253.734375 L 1430.199219 1251.964844 C 1436.683594 1228.367188 1441.410156 1206.542969 1445.535156 1185.304688 C 1457.917969 1123.957031 1466.179688 1079.71875 1519.84375 1053.171875 L 1531.636719 1047.277344 Z M 1308.125 1312.722656 C 1311.664062 1306.234375 1314.613281 1300.339844 1317.5625 1295.027344 C 1332.894531 1265.53125 1340.5625 1251.964844 1378.304688 1238.984375 C 1364.152344 1262.585938 1334.074219 1301.519531 1308.125 1312.722656 Z M 1308.125 1312.722656 "
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#ffffff",
      fillOpacity: 1
    },
    d: "M 1285.125 826.105469 C 1275.691406 832.589844 1269.792969 840.261719 1266.84375 849.703125 C 1266.253906 850.882812 1266.253906 852.0625 1266.253906 853.242188 C 1265.074219 861.496094 1267.433594 870.347656 1273.921875 877.429688 C 1282.769531 886.863281 1296.921875 892.765625 1311.664062 892.175781 C 1357.664062 890.996094 1468.535156 888.628906 1508.632812 895.125 C 1533.992188 899.25 1560.53125 896.300781 1582.941406 885.683594 C 1589.433594 882.734375 1595.332031 880.375 1601.226562 879.199219 C 1609.480469 876.839844 1617.152344 876.242188 1623.636719 875.652344 C 1617.152344 877.429688 1611.25 879.785156 1605.941406 882.734375 C 1591.792969 890.398438 1583.53125 901.609375 1582.351562 914.585938 C 1578.226562 961.1875 1694.40625 979.476562 1707.378906 981.246094 L 1713.28125 981.835938 L 1713.871094 975.941406 C 1714.460938 970.625 1717.410156 965.910156 1722.125 962.960938 C 1742.175781 949.394531 1792.304688 959.417969 1809.402344 964.140625 L 1837.707031 971.804688 L 1814.714844 953.523438 C 1506.277344 711.664062 1331.714844 794.84375 1285.125 826.105469 Z M 1285.125 826.105469 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#ffffff",
      fillOpacity: 1
    },
    d: "M 1252.695312 935.171875 L 1247.976562 931.632812 L 1252.695312 935.171875 C 1263.308594 922.199219 1264.488281 901.550781 1255.644531 887.394531 C 1250.335938 879.140625 1243.847656 877.363281 1239.71875 877.953125 C 1228.515625 878.542969 1216.71875 892.699219 1203.15625 922.789062 C 1157.746094 1024.25 1194.898438 1101.523438 1196.667969 1104.46875 L 1207.875 1100.34375 C 1187.824219 1026.019531 1232.644531 960.539062 1252.695312 935.171875 Z M 1252.695312 935.171875 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#ffffff",
      fillOpacity: 1
    },
    d: "M 1698.535156 758.1875 C 1440.820312 586.53125 1276.867188 728.691406 1269.792969 734.589844 L 1276.867188 744.03125 C 1285.714844 738.722656 1491.539062 618.382812 1742.167969 820.714844 C 1784.042969 854.925781 1817.65625 885.609375 1841.246094 913.332031 L 1877.226562 955.214844 L 1850.6875 906.25 C 1823.558594 857.292969 1772.253906 807.148438 1698.535156 758.1875 Z M 1698.535156 758.1875 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#ffffff",
      fillOpacity: 1
    },
    d: "M 1190.769531 916.296875 L 1172.484375 898.011719 C 1172.484375 889.160156 1171.894531 855.539062 1183.691406 816.015625 L 1185.460938 809.53125 L 750.234375 742.871094 L 1164.230469 906.265625 Z M 1190.769531 916.296875 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#ffffff",
      fillOpacity: 1
    },
    d: "M 1161.289062 1020.769531 L 1160.699219 1012.519531 L 928.933594 1110.441406 L 1178.390625 1113.976562 L 1184.289062 1113.976562 L 1184.289062 1106.894531 L 1183.699219 1105.714844 C 1184.289062 1105.125 1163.058594 1047.90625 1161.289062 1020.769531 Z M 1161.289062 1020.769531 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#ffffff",
      fillOpacity: 1
    },
    d: "M 1234.996094 723.382812 C 1258.582031 698.015625 1288.660156 678.550781 1324.632812 665.574219 L 1331.710938 663.214844 L 1107.019531 338.773438 L 1227.917969 731.050781 Z M 1234.996094 723.382812 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#ffffff",
      fillOpacity: 1
    },
    d: "M 1557.582031 656.171875 L 1566.433594 657.941406 L 1446.125 140.609375 L 1442 646.144531 L 1447.894531 646.144531 C 1481.507812 646.144531 1518.074219 649.683594 1557.582031 656.171875 Z M 1557.582031 656.171875 "
  }), /*#__PURE__*/React.createElement("g", {
    clipRule: "nonzero",
    clipPath: "url(#141ad62184)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#ffffff",
      fillOpacity: 1
    },
    d: "M 1811.1875 811.855469 L 1816.492188 818.347656 L 1965.699219 546.40625 L 1694.414062 710.394531 L 1702.078125 715.703125 C 1740.417969 739.890625 1776.976562 772.335938 1811.1875 811.855469 Z M 1811.1875 811.855469 "
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightLogoLightGreen);
export default __webpack_public_path__ + "static/media/LightLogoLightGreen.b2b2f71981da94a8245b3ffa2460d0a8.svg";
export { ForwardRef as ReactComponent };